export default __webpack_public_path__ + "static/media/back-arrow-primary-outline.51c445ca.svg";